import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PersistentRadioPlayer } from "@/components/PersistentRadioPlayer";
import { EngagementLayer } from "@/components/EngagementLayer";
import { PhoneOtpModal } from "@/components/PhoneOtpModal";
import { SubscribeGate } from "@/components/SubscribeGate";
import { WhatsAppSupport } from "@/components/WhatsAppSupport";
import { SupportChat } from "@/components/SupportChat";
import { InstallPWA } from "@/components/InstallPWA";
import { SafeZone, PageFallback } from "@/components/AppErrorBoundary";

// Every block is isolated so one failing widget can never take the whole app down.
export const Layout = () => {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-[#0A0C10] flex flex-col">
      <SafeZone name="header"><Header /></SafeZone>
      <main className="flex-1 pb-28">
        <SafeZone name={`page ${pathname}`} resetKey={pathname} fallback={<PageFallback />}><Outlet /></SafeZone>
      </main>
      <SafeZone name="footer"><Footer /></SafeZone>
      <SafeZone name="radio-player"><PersistentRadioPlayer /></SafeZone>
      <SafeZone name="engagement"><EngagementLayer /></SafeZone>
      <SafeZone name="otp"><PhoneOtpModal /></SafeZone>
      <SafeZone name="subscribe"><SubscribeGate /></SafeZone>
      <SafeZone name="whatsapp"><WhatsAppSupport /></SafeZone>
      <SafeZone name="support"><SupportChat /></SafeZone>
      <SafeZone name="install"><InstallPWA /></SafeZone>
    </div>
  );
};
